import { useQuery } from '@tanstack/react-query';
import { getStatusOfVerificationProcess } from 'src/common/services/process';
import { verificationQueryKeys } from 'src/common/verificationQueryKeys';

export const useStatusOfVerificationProcessQuery = (
  verificationId?: string
) => {
  return useQuery(
    verificationQueryKeys.status(verificationId),
    () =>
      verificationId
        ? getStatusOfVerificationProcess(verificationId)
        : undefined,
    {
      enabled: Boolean(verificationId),
    }
  );
};
